// extracted by mini-css-extract-plugin
export default {"shortcuts":"Shortcuts_shortcuts__cSFiZ"};